<template>
  <div id="app-pc">
    <div class="menu-container">
      <div>
        <span v-for="(menu, index) in menus" :key="menu.name">
          <a
            v-if="menu.show"
            :class="{ active: activeIndex == index }"
            href="javascript:;"
            class="menu-item"
            @click="handleToUrl(menu, index)"
          >
            {{ menu.label }}
          </a>
        </span>

        <div class="logout" @click="logout">
          <img src="../../assets/visitor/exit.png" alt="" /> 退出登录
        </div>
      </div>
      <div v-if="activeIndex == 1">
        <span v-for="sub in subMenus" :key="sub.name">
          <a
            v-if="sub.show"
            :class="{ active: $route.name === sub.name }"
            href="javascript:;"
            class="menu-item1"
            @click="$router.replace({ name: sub.name })"
          >
            {{ sub.label }}
          </a>
        </span>
      </div>
      <div v-else>
        <span v-for="sub in roleMenus" :key="sub.name">
          <a
            v-if="sub.show"
            :class="{ active: $route.name === sub.name }"
            href="javascript:;"
            class="menu-item1"
            @click="$router.replace({ name: sub.name })"
          >
            {{ sub.label }}
          </a>
        </span>
      </div>
    </div>
    <div v-if="showPage" class="page_con">{{ showPage }}</div>
    <div class="pages" v-else>
      <router-view class="page-container" :queryRoleAllot="queryRole" />
    </div>
  </div>
</template>

<script>
import api from "@/apis";
export default {
  name: "pc",
  data() {
    return {
      menus: [
        { label: "账号管理", name: "account", show: false },
        { label: "访客管理", name: "visitor", show: false }
      ],
      subMenus: [
        { label: "访客管理", name: "visitor", show: false },
        { label: "车辆管理", name: "carManage", show: false },
        { label: "车辆放行", name: "carRelease", show: false },
        { label: "物品及其他放行", name: "dormManage", show: false }
      ],
      roleMenus: [
        { label: "账号管理", name: "account", show: false },
        { label: "角色管理", name: "roleManage", show: false },
        { label: "保安管理", name: "securityManage", show: false }
      ],
      showPage: "",
      dataType: [],
      activeIndex: 1
    };
  },
  mounted() {
    this.queryRole(sessionStorage.getItem("username"));
  },
  methods: {
    // 退出登录
    logout() {
      sessionStorage.setItem("username", "");
      this.$router.replace({
        path: "/visitorLogin"
      });
    },
    // 查询角色
    queryRole(username) {
      api.queryRoleApi({ username }).then(res => {
        if (res.code == 200) {
          this.dataType = res.data.map(item => item.dataType);
          console.log(this.dataType);
          if (this.dataType.includes(4)) {
            this.menus.forEach(item => (item.show = true));
            this.subMenus.forEach(item => (item.show = true));
            this.roleMenus.forEach(item => (item.show = true));
          } else if (this.dataType.includes(1)||this.dataType.includes(2)||this.dataType.includes(3)) {
            // 账号
            this.menus[0].show = false;
            this.roleMenus[0].show = false;
            this.roleMenus[1].show = false;
            this.roleMenus[2].show = false;
            //访客
            this.menus[1].show = true;
            this.subMenus[0].show = true;
            this.subMenus[1].show = false;
            this.subMenus[2].show = true;
            this.subMenus[3].show = true;

            this.$router.replace({
              path: "/visitor"
            });
          } else {
            this.menus.forEach(item => (item.show = false));
            this.showPage = "暂无权限";
          }
        }
      });
    },
    //跳转
    handleToUrl(menu, index) {
      this.activeIndex = index;
      this.$router.replace({ name: menu.name });
    }
  }
};
</script>

<style lang="scss" scoped>
#app-pc {
  background: #f6f6f6;
}
.menu-container {
  position: relative;
  padding: 0 46px;
  // height: 40px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px #f8f9fa;
  .logout {
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 10px;
    color: #7d7d7d;
    font-weight: 600;
    cursor: pointer;
    img {
      display: block;
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
  .menu-item {
    margin-right: 40px;
    display: inline-block;
    line-height: 30px;
    font-size: 10px;
    text-decoration: none;
    font-weight: 500;
    color: #3d3d3d;

    &.active {
      color: #008755;
      font-weight: bold;
    }
  }
  .menu-item1 {
    margin-left: -5px;
    margin-right: 20px;
    display: inline-block;
    line-height: 25px;
    font-size: 9px;
    text-decoration: none;
    font-weight: 500;
    color: #3d3d3d;
    padding: 0 5px;
    &.active {
      color: #008755;
      font-weight: bold;
      background-color: #e6f7ff;
      border-bottom: 2px solid #008755;
    }
  }
}
.page_con {
  line-height: calc(100vh - 200px);
  text-align: center;
  background: #fff;
}

.pages {
  padding: 10px 18px;
}

.page-container {
  padding: 0.1rem 25px 0;
  background: #fff;
  border-radius: 8px;
}
</style>
